import Login from "./components/Login.vue";
import ConferenceCallDetails from "./components/ConferenceCallTracker/ConferenceCallDetails.vue";
import UserList from "./components/User/UserList.vue";
import { createRouter,createWebHistory } from "vue-router";
import store from './store/store';
import {GET_USER_TOKEN, IS_AUTH_USER} from './store/storeconstants';
import KeywordManagement from "./components/KeywordManagement/KeywordManagement.vue";
const routes=[
    {
        name: "Login",
        component: Login,
        path: "/login",
        meta: {
            title : "Login",
             auth: false,
        },
    },
    {
        path: "/:catchAll(.*)",
        redirect: {
            name: 'Login',
          },
      },
    {
        name: "conferenceDetails",
        component: ConferenceCallDetails,
        path: "/conferenceDetails",
        meta: {
            title : "Conference Call Tracker",
            auth: true,
        },
    },
    {
        name: "userList",
        component: UserList,
        path: "/userList",
        meta: {
            title : "User List",
            auth: true,
        },
    },
     {
        name: "keywordManagement",
        component: KeywordManagement,
        path: "/keywordManagement",
        meta: {
            title : "Keyword Management",
            auth: true,
        },
    },
]

const router= createRouter({
    history : createWebHistory(process.env.BASE_URL),
    routes,
});


router.beforeEach((to,from,next)=>{
    if(to.meta.auth && !store.getters[`auth/${IS_AUTH_USER}`])
    {
        next('/login');
    }   
    else
    {
        next();
    }    
    document.title=`${'CCT- '+to.meta.title}`;
});



export default router;
